/*
choixPAGE==0 : nouveau qcm
choixPAGE==1 : modifier-supprimer
choixPAGE==2 : le menu QCM pour le qcm sélectionné !
choixPAGE==3 : liste des qcm

choixQCM=-1 : pas choisi
choixQCM>0 : idqcm

*/

app.directive('restrictInput', [function () {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var ele = element[0];
      var regex = RegExp(attrs.restrictInput);
      var value = ele.value;

      ele.addEventListener('keyup', function (e) {
        if (ele.value == '') {
          ele.value = 0;
        } else if (ele.value < 0) {
          ele.value = 0;
        } else if (ele.value > 16) {
          ele.value = 16;
        } else if (regex.test(ele.value)) {
          value = ele.value;
        } else {
          ele.value = value;
        }
      });
    }
  };
}]);
/*
app.directive('restrictInput2', [function(toastr) {
                return {
                  restrict: 'A',
                  link: function($scope, element, attrs) {
                    var ele = element[0];
                    var regex = RegExp(attrs.restrictInput);
                    var value = ele.value;

                    ele.addEventListener('keyup', function(e) {
                      var nbmax=120;
                      if ($scope.qcmModifie.remord==1){
                        nbmax=60;
                      }
                                    if (ele.value == '') {
                        ele.value = '0';
                      } else if (ele.value < 1) {
                        ele.value = 0;
                      } else if (ele.value > nbmax) {
                        ele.value = nbmax;
                        toastr.error(nbmax+' '+'___questions maximum par
page___'); } else if (regex.test(ele.value)) { value = ele.value; } else {
                        ele.value = value;
                      }
                    });
                  }
                };
              }]);
*/

app.controller(
  'lstCtrl',
  function (
    $rootScope, $scope, listeQCM, ngTableParams, $filter, $location,
    ServiceQcm, toastr, services, $auth) {
    var _DEBUG = 0;
    $scope.url_ = $rootScope.url_;

    $scope.menuSelectionne = 1;
    $rootScope.menu1 = 10;

    /**********************************/
    //$scope.nombrePage=2
    //$scope.nombrePageTab
    //= {"1":10,"2":10,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0}
    $scope.init = function () {
      $scope.loader = 1;
      $scope.choixPAGE = 3;
      new listeQCM.chargeListeQCM()
        .then(function (data) {
          //$location.path('/QCMscanner');

          $scope.listeQCM2 = data;
          $rootScope.listeQCM = $scope.listeQCM2;
          $scope.choixPAGE = 3;
          $scope.choixQCM = -1;
          toastr.info('___Vous pouvez créer un nouveau QCM___');

          /*************************************************************/
          $scope.data = $scope.listeQCM2;  // n3
          $scope.tableDesCopies = new ngTableParams(
            {
              page: 1,    // show first page
              count: 10,  // count per page
              sorting: { id: 'Numero' }

            },
            {
              total: $scope.listeQCM2.length,
              getData: function ($defer, params) {
                //$scope.var  = params//pour affichage uniquement (à
                // supprimer apres)  !!
                $scope.data = params.filter() ?
                  $filter('filter')($scope.listeQCM2, params.filter()) :
                  $scope.listeQCM2;
                $scope.data = params.sorting() ?
                  $filter('orderBy')($scope.data, params.orderBy()) :
                  $scope.listeQCM2;
                $scope.data = $scope.data.slice(
                  (params.page() - 1) * params.count(),
                  params.page() * params.count());

                $defer.resolve($scope.data);
              }
            });
          /*************************************************************/

          $scope.loader = 0;
        })
        .catch(function (response) {
          // if (_DEBUG) console.info('message='+response.data.message+' et
          // ='+ response.status); throw(response); alert("lst-ERREUR");
          toastr.error('___session expirée___?????????');
          $scope.loader = 0;
          $location.path('/logout');
          // $location.path('/QCMscanner');
        });

      $scope.onfocus1 = false;
      $scope.onfocus2 = false;
      $scope.onfocus3 = false;
      $scope.onfocus4 = false;
      $scope.onfocus5 = false;
      $scope.onfocus6 = false;
      $scope.onfocus7 = false;

      $scope.loader = 0;
    };
    /******************************************/
    $scope.nouveauQcm = function (val) {
      if (typeof (val) == 'number') {  // nouveau qcm
        $scope.choixPAGE = 0;
        // astuce : id = id du user !!!
        $scope.qcmModifie = {
          'id': 0,
          'date': '',
          'UneSeuleReponse': true,
          'nbNumero': 5,
          'modeCalcul': '0',
          'nbQuestion': 20,
          'libelle': '',
          'Matiere': '',
          'ptJuste': '1',
          'ptFaux': '-0.1',
          'ptVide': '0',
          'nbReponse': '5',
          'phrase': '___Répondre aux questions en noircissant les cases___',
          'consigne': '___Ne pas écrire en dehors de ce cadre___',
          'nom': '___Nom :___',
          'prenom': '___Prénom :___',
          'number': '___Saisir votre numéro d\'étudiant___',
          'cas': 0,
          'typeCoin': 0,
          'remord': 0
        };

        $scope.qcmAvecQuestionDansLaGrille = -1  // par défaut
        //$scope.nombrePageTab
        //= {"1":10,"2":10,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0}
        $scope.nombrePageTab = {
          1: 10,
          2: 10,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0
        };
        $scope.nombrePage = 2;
        $scope.cadre = '___avec des cadres___';
        $scope.cercle = '___avec des cercles___';
        $scope.uneSeuleReponse = true;
        $scope.remord = 0;
        $scope.qcmModifie.typeCoin = $scope.cercle;
      }
    };
    /******************************************/
    $scope.lesgroupes = function () {
      $location.path('/groupe');
    };
    /******************************************/
    $scope.$watch('qcmModifie.nbQuestion', function (newValue, oldValue) {
      if (newValue == oldValue) return;

      oldValue = parseInt(oldValue);
      newValue = parseInt(newValue);
      var nbmax = 120;
      if ($scope.qcmModifie.remord == 1) {
        nbmax = 60;
      }
      if (newValue > nbmax) {
        $scope.qcmModifie.nbQuestion = nbmax;
        toastr.error(
          nbmax + ' ' +
          '___questions maximum par page___');
      }
    });
    /******************************************/
    $scope.$watch('qcmModifie.remord', function (newValue, oldValue) {
      if (newValue == oldValue) return;

      oldValue = parseInt(oldValue);
      newValue = parseInt(newValue);
      if ($scope.qcmModifie.remord == 1) {
        if ($scope.qcmModifie.nbQuestion > 60) {
          $scope.qcmModifie.nbQuestion = 60;
          toastr.error(
            60 + ' ' +
            '___questions maximum par page___');
        }
      }
    });
    /******************************************/
    $scope.$watch(
      'nombrePage',
      function (
        newValue,
        oldValue) {  // nouveau type de QCM : multi-Pages !!!
        // alert("click, oldValue="+oldValue + "  newValue="+
        // newValue)
        if (newValue == oldValue) return;
        oldValue = parseInt(oldValue);
        newValue = parseInt(newValue);
        var lg = 16;
        var i = 0;
        if (newValue > oldValue) {  // ajoute des pages
          for (i = oldValue + 1; i <= newValue; i++) {
            // alert('i='+i)
            $scope.nombrePageTab[i] = 10;
            //$scope.nombrePageTab.splice(i,1,10)
          }
        } else {  // on enlève des pages
          for (i = newValue + 1; i <= lg; i++) {
            // alert('i='+i)
            $scope.nombrePageTab[i] = 0;
            //$scope.nombrePageTab.splice(i,1,0)
          }
        }
        $scope.nbQuestionCalcul();
      });
    /******************************************/
    $scope.nbQuestionCalcul =
      function () {  // nouveau type de QCM : multi-Pages !!!
        var nb = 0;
        for (i = 1; i < 16; i++) {
          nb = nb + parseInt($scope.nombrePageTab[i]);
        }
        $scope.qcmModifie.nbQuestion = nb;
      };

    /******************************************/
    $scope.modifQcm = function (val) {  // avant l'écran de modif (préparation)
      $scope.option1 = [
        { 'v': 2, 'label': '2 (A-B)' }, { 'v': 3, 'label': '3 (A-B-C)' },
        { 'v': 4, 'label': '4 (A-B-C-D)' }, { 'v': 5, 'label': '5 (A-B-C-D-E)' }
      ];
      $scope.nbReponse = val.nbReponse - 1;

      $scope.option2 = [
        { 'v': 1, 'label': '1' }, { 'v': 2, 'label': '2' },
        { 'v': 3, 'label': '3' }, { 'v': 4, 'label': '4' },
        { 'v': 5, 'label': '5' }, { 'v': 6, 'label': '6' },
        { 'v': 7, 'label': '7' }, { 'v': 8, 'label': '8' },
        { 'v': 9, 'label': '9' }, { 'v': 10, 'label': '10' }
      ];
      $scope.nbNumero = val.nbNumero - 1;
      $scope.qcmModifie = val;

      $scope.qcmModifie_avant = angular.copy(val);  // sauvegarde

      $scope.choixPAGE = 1;
      $scope.qcmModifie.phrase =
        '___Répondre aux questions en noircissant les cases___';
      $scope.qcmModifie.consigne =
        '___Ne pas écrire en dehors de ce cadre___';
      $scope.qcmModifie.nom = '___Nom :___';
      $scope.qcmModifie.prenom = '___Prénom :___';
      $scope.qcmModifie.number = '___Saisir votre numéro d\'étudiant___';

      if ($scope.qcmModifie.UneSeuleReponse == 1) {
        $scope.qcmModifie.modeCalcul = '0';
        $scope.qcmModifie.UneSeuleReponse = true;
      } else if ($scope.qcmModifie.UneSeuleReponse == 0) {
        $scope.qcmModifie.modeCalcul = '0';
        $scope.qcmModifie.UneSeuleReponse = false;
      } else if ($scope.qcmModifie.UneSeuleReponse == 10) {
        $scope.qcmModifie.modeCalcul = '1';
        $scope.qcmModifie.UneSeuleReponse = false;
      } else if ($scope.qcmModifie.UneSeuleReponse == 20) {
        $scope.qcmModifie.modeCalcul = '2';
        $scope.qcmModifie.UneSeuleReponse = false;
      } else if ($scope.qcmModifie.UneSeuleReponse == 30) {
        $scope.qcmModifie.modeCalcul = '3';
        $scope.qcmModifie.UneSeuleReponse = false;
      } else if ($scope.qcmModifie.UneSeuleReponse == 40) {
        $scope.qcmModifie.modeCalcul = '4';
        $scope.qcmModifie.UneSeuleReponse = false;
      }

      if ($scope.qcmModifie.remord) {
        /*            $scope.qcmModifie.nbQuestion = 1000 +
           $scope.qcmModifie.nbQuestion; if
           ($scope.qcmModifie.nbQuestion>1000){ $scope.qcmModifie.nbQuestion =
           $scope.qcmModifie.nbQuestion - 1000;
        */
        $scope.remord = 1;
      } else {
        $scope.remord = 0;
      }
    };

    /******************************************/
    $scope.modifier = function () {  // après l'ecran de modif : action
      //$scope.qcmModifie.cas = cas;
      $scope.loader = 1;
      if ($scope.qcmModifie.UneSeuleReponse == 1)
        $scope.qcmModifie.UneSeuleReponse = 1;
      else {
        if ($scope.qcmModifie.modeCalcul == '2')
          $scope.qcmModifie.UneSeuleReponse = 20;
        else if ($scope.qcmModifie.modeCalcul == '3')
          $scope.qcmModifie.UneSeuleReponse = 30;
        else if ($scope.qcmModifie.modeCalcul == '4')
          $scope.qcmModifie.UneSeuleReponse = 40;
        else if ($scope.qcmModifie.modeCalcul == '1')
          $scope.qcmModifie.UneSeuleReponse = 10;
        else if ($scope.qcmModifie.modeCalcul == '0')
          $scope.qcmModifie.UneSeuleReponse = 0;
        else
          return;
      };

      services.modifierQCM($scope.qcmModifie)
        .then(function (data) {
          //$rootScope.effaceQCM = data.data;
          // le qcm modifié... changer dans le rootscope et le scope...
          new listeQCM.chargeListeQCM().then(function (data) {
            $scope.listeQCM2 = data;
            $rootScope.listeQCM = $scope.listeQCM2;
            $scope.choixPAGE = 3;
            $scope.choixQCM = -1;
          });

          $scope.loader = 0;
        })
        .catch(function (response) {
          toastr.error('___session expirée___');
          $scope.loader = 0;
          $location.path('/QCMscanner');
        });


      $scope.qcmModifie = null;
      $scope.choixPAGE = 3;
    };

    /******************************************/
    $scope.dupliquer = function (idqcm) {
      services.dupliquerQCM(idqcm)
        .then(function (data) {
          $scope.loader = 1;
          // maj de la liste !
          $rootScope.listeQCM = [];
          new listeQCM.chargeListeQCM().then(function (data) {
            $scope.listeQCM2 = data;
            $rootScope.listeQCM = $scope.listeQCM2;
            $scope.loader = 0;
            $scope.tableDesCopies.reload();
          });
        })
        .catch(function (response) {
          toastr.error('___session expirée___');
          $scope.loader = 0;
          //$location.path('/QCMscanner');
        });
      ;

      $scope.qcmModifie = null;
      $scope.choixPAGE = 3;
    };

    /******************************************/
    $scope.ajouter = function () {
      // 1. dire au serveur qu'on ajoute un qcm !
      // Multi-page
      $scope.loader = 1;


      if ($scope.qcmModifie.remord)
        $scope.qcmModifie.nbQuestion =
          1000 + parseInt($scope.qcmModifie.nbQuestion);

      if ($scope.qcmAvecQuestionDansLaGrille) {
        nbQuestion = 0;
        p2 = $scope.nombrePage;
        p3 = $scope.nombrePageTab;
        for (i = 0; i < p2; i++) nbQuestion += $scope.nombrePageTab[i];
        $scope.qcmModifie.nbQuestion = nbQuestion;
      } else {
        p2 = 0;
        p3 = { '1': $scope.qcmModifie.nbQuestion };
      }

      if ($scope.qcmModifie.typeCoin == $scope.cadre) {
        $scope.qcmModifie.typeCoin = 0;
      } else {
        $scope.qcmModifie.typeCoin = 1;
      }

      //$scope.nombrePage = "2"
      //$scope.nombrePageTab
      //= {"1":10,"2":10,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0}

      // this.ajouter=function(listeQCM, nouveauQcm){
      // new listeQCM.ajouterQCM($scope.qcmModifie, p2,
      // p3).then(function(data) {
      services.ajouterQCMmultipage($scope.qcmModifie, p2, p3)
        .then(function (data) {
          // ALTER TABLE `qcm` ADD `remord` BOOLEAN NOT NULL DEFAULT FALSE
          // AFTER `typeCoin`;

          // 2. recharger la liste des qcm ! (on pourrait faire mieux !)

          new listeQCM.chargeListeQCM()
            .then(function (data) {
              $scope.listeQCM2 = data;
              $rootScope.listeQCM = $scope.listeQCM2;
              $scope.choixPAGE = 3;
              $scope.choixQCM = -1;

              $scope.data = $scope.listeQCM2;  // n3
              $scope.tableDesCopies.reload();

              toastr.info('___Vous pouvez créer un nouveau QCM___');
              $scope.loader = 0;
            })
            .catch(function (response) {
              toastr.error('___session expirée___');
              $scope.loader = 0;
              $location.path('/QCMscanner');
            });

          $scope.qcmModifie = null;
          $scope.choixPAGE = 3;
        })
        .catch(function (response) {
          toastr.error('___session expirée___');
          $scope.loader = 0;
          $location.path('/QCMscanner');
        });
      $scope.loader = 0;
    };



    /******************************************************************************************************/
    $scope.delete2 = function (id) {  // supprimer qcm
      $scope.qcmModifie = { 'id': id };
      $scope.delete();
    };
    /******************************************************************************************************/
    $scope.delete = function () {  // supprimer qcm
      services.effaceQCM($scope.qcmModifie.id)
        .then(function (data) {
          $scope.loader = 1;
          new listeQCM.chargeListeQCM()
            .then(function (data) {
              $scope.listeQCM2 = data;
              $rootScope.listeQCM = $scope.listeQCM2;
              $scope.choixPAGE = 3;
              $scope.choixQCM = -1;
              toastr.info('___Vous pouvez créer un nouveau QCM___');

              $scope.data = $scope.listeQCM2;  // n3
              $scope.tableDesCopies.reload();

              $scope.loader = 0;
            })
            .catch(function (response) {
              toastr.error('___session expirée___');
              $scope.loader = 0;
              $location.path('/QCMscanner');
            });
        })
        .catch(function (response) {
          if (_DEBUG) console.info('P2');
          $scope.loader = 0;

          toastr.error('___session expirée___');
          $location.path('/QCMscanner');
        });


      $scope.choixPAGE = 3;
      $scope.qcmModifie = {};
      $scope.choixQCM = 0;
      $rootScope.qcmSelectionne = {};
    };
    /******************************************************************************************************/

    $scope.cancel = function () {  // revenir à la liste des qcm
      $rootScope.afficheListeQcm = 1;
      $scope.init();
    };


    /******************************************************************************************************/
    $scope.close = function (result) {  // modal !
      close(result, 500);  // close, but give 500ms for bootstrap to animate
    };

    /******************************************************************************************************/
    /******************************************************************************************************/
    $scope.choisirQcm = function (qcm) {  //, service_Charge1qcm
      //$scope.loader=1;
      $rootScope.qcmSelectionne = qcm;
      $location.path('/1qcm');
    };
    /******************************************************************************************************/

    $scope.isAuthenticated = function () {  //, service_Charge1qcm
      $rootScope.qcmSelectionne = [];
      $scope.choixPAGE = 3;
      return $auth.isAuthenticated();

    };

    /******************************************************************************************************/
  });
